import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=44b33a79&scoped=true&"
import script from "./goodsDialog.vue?vue&type=script&lang=js&"
export * from "./goodsDialog.vue?vue&type=script&lang=js&"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=44b33a79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b33a79",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b33a79')) {
      api.createRecord('44b33a79', component.options)
    } else {
      api.reload('44b33a79', component.options)
    }
    module.hot.accept("./goodsDialog.vue?vue&type=template&id=44b33a79&scoped=true&", function () {
      api.rerender('44b33a79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/goodsDialog.vue"
export default component.exports